// extracted by mini-css-extract-plugin
export default {"page":"styles_page__+locc","leftPanel":"styles_leftPanel__PWCma","rightPanel":"styles_rightPanel__jIwAy","form":"styles_form__Qr52C","footerError":"styles_footerError__mtoUt"};